var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"tag","data-hover":_vm.hasItemId}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }